import type { Track } from '@blackblack/shared';
import { Link } from '../../lib/router';
import { player, usePlayer } from '../../state/player';
import { Icon } from '../../components/ui/Icon';
import { Cover } from './Cover';
import { Equalizer } from './TrackRow';
import styles from './music.module.css';

/** Square card for horizontal shelves; the play button plays the shelf from here. */
export function TrackCard({ track, list, index, context }: { track: Track; list: Track[]; index: number; context: string }) {
  const isCurrent = usePlayer((s) => s.queue[s.index]?.id === track.id);
  const playing = usePlayer((s) => s.playing);
  return (
    <div className={styles.card}>
      <Link to={`/sound/${track.id}`} className={styles.cardArt}>
        <Cover src={track.coverUrl} size="100%" radius={14} />
      </Link>
      <button
        className={styles.cardPlay}
        aria-label={isCurrent && playing ? `Pauzeer ${track.title}` : `Speel ${track.title}`}
        onClick={() => (isCurrent ? player.toggle() : player.playTracks(list, index, context))}
        disabled={!track.streamUrl}
      >
        {isCurrent && playing ? <Equalizer /> : <Icon name="play" size={18} />}
      </button>
      <Link to={`/sound/${track.id}`} className={styles.cardTitle}>
        {track.title}
      </Link>
      <Link to={`/artist/${track.artist.id}`} className={styles.cardSub}>
        {track.artist.name}
      </Link>
    </div>
  );
}
